import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PageContentQueryResponseDto } from 'enrollment/queries/usePageContentQuery/types';
import { SanitizedPageContent } from './SanitizedContent';
import { PageContentBlock, PageContentModal } from './PageContentBlock';
import { SanitizedStyledWrapper } from './SanitizedPageContentStyled';

export interface PageContentWrapperProps {
  pageContent?: PageContentQueryResponseDto;
  translatedTitle?: string;
  showTitle?: boolean;
}

export const PageContent = (props: PageContentWrapperProps) => {
  useTranslation();
  const { pageContent, translatedTitle, showTitle = true } = props;
  const [modalPopupContent, setModalPopupContent] = useState({ title: '', body: '' });

  if (!pageContent || !pageContent.data) {
    return <div />;
  }

  const {
    page_title: title,
    page_subtitle: subTitle,
    page_text: pageText,
    content_blocks: contentBlocks,
    required_page_content: requiredPageContent,
  } = pageContent.data;
  const contentTitle = translatedTitle || subTitle || title || 'About';
  const requiredPageText = requiredPageContent?.page_text;
  const requiredContentBlocks = requiredPageContent?.content_blocks;

  return (
    <>
      {showTitle && <h1>{contentTitle}</h1>}

      {pageText && (
        <SanitizedStyledWrapper>
        <SanitizedPageContent
          html={pageText}
          classes={`page-content ${requiredContentBlocks ? ' border-bottom mb-4 pb-4 ' : ''}`}
        />
        </SanitizedStyledWrapper>
      )}

      <div className="content-blocks">
        {
          contentBlocks?.map((contentBlock) => {
            return (
              <div className='mt-5' key={`nonRequired-${contentBlock.name}`}>
                <PageContentBlock
                  key={contentBlock.slot_num}
                  contentBlock={contentBlock}
                  setModalPopupContent={setModalPopupContent}
                />
              </div>
            );
          })
        }
      </div>

      {requiredPageText && <SanitizedPageContent html={requiredPageText} classes="required-page-content" />}

      <div className="required-content-blocks">
        {
          requiredContentBlocks?.map((contentBlock) => {
            return (
              <div className='mt-5' key={`required-${contentBlock.name}`}>
                <PageContentBlock
                  key={contentBlock.slot_num}
                  contentBlock={contentBlock}
                  setModalPopupContent={setModalPopupContent}
                />
              </div>
            );
          })
        }
      </div>

      <PageContentModal title={modalPopupContent.title} body={modalPopupContent.body} />
    </>
  );
};
